import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import type { AdPartner } from '../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { SavePostbackRequestActionPayload, SavePostbackResponseActionPayload } from '../AdPartner.types';

const SavePostback = new ReduxAsyncAction<
  'AD_PARTNER_SAVE_POSTBACK',
  SavePostbackRequestActionPayload,
  SavePostbackResponseActionPayload
>('AD_PARTNER_SAVE_POSTBACK');

SavePostback.registerRequest(async ({ postback }) => {
  const { data } = await dash_api.post<AdPartner>(`/v1/ad-networks/postback`, {
    postback,
  });

  return {
    partner: data,
    event: postback.event,
  };
});

export const SAVE_POSTBACK = SavePostback.actionNamespaceConstants;

export const savePostback = SavePostback.request;

export type SavePostbackResponseAction = Action<typeof SAVE_POSTBACK.response> & { data: SavePostbackResponseActionPayload };
